<template>
    <section id="form_section">
        <Toast />

        <div class="container">
            <div class="service_header">
                <h1 class="main_title">Сервіс підбору шин</h1>
                <div>
                <a href="javascript:void(0)" v-on:click="modal_info = true" class="info_btn">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path id="info-icon" d="M9.5 5H11.5V7H9.5V5ZM9.5 9H11.5V15H9.5V9ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18Z" fill="#356EEF"/>
                    </svg>
                    Опис роботи сервісу
                </a>
                </div>
            </div>

            <div class="services-list">
                <div class="service-item">
                    <a href="/kalkulyator-pidboru-zhorstkoyi-shini">
                        <div class="service-item_content">
                            <div class="service_img">
                                <img width="100" height="82" src="/img/calc_1.png" />
                            </div>
                            <div class="service-item_info">
                                <p class="service_title">Жорстка шина</p>
                                <p class="service_description">Підібрати жорстку мідну або алюмінієву шину</p>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="service-item">
                    <a href="/kalkulyator-pidboru-gnuchkoyi-shini">
                        <div class="service-item_content">
                            <div class="service_img">
                                <img width="100" height="82" src="/img/calc_2.png" />
                            </div>
                            <div class="service-item_info">
                                <p class="service_title">Гнучка шина</p>
                                <p class="service_description">Підібрати шину гнучку в ізоляції луджену або червону</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>

        </div>


        <div class="overlay" v-if="modal_info || modal_kalk_info || modal_total" v-on:click="closeModals"></div>
        
        <div class="modal description_modal" v-if="modal_info">
            <div class="modal_container">
                <div class="modal_header">
                    <p class="modal_header_title">Опис роботи сервісу</p>
                    <svg class="close_modal" v-on:click="modal_info = false" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 2.26151L12.59 0.709961L7 6.86112L1.41 0.709961L0 2.26151L5.59 8.41266L0 14.5638L1.41 16.1154L7 9.96421L12.59 16.1154L14 14.5638L8.41 8.41266L14 2.26151Z" fill="#356EEF"/>
                    </svg>
                </div>
                <div class="modal_content" v-html="text"></div>
            </div>
        </div>  

    </section>
</template>

<script>
import CommonLayout from "@/Layouts/CommonLayout";

export default {
    props: {
        text: {
            type: String,
            required: false,
        },
    },
    layout: CommonLayout,

    data() {
        return {
            modal_info: false,
        }
    },

    methods: {
        closeModals() {
            this.modal_info = false;
        },
    }
};
</script>

<style scoped>
#form_section {
    max-width: 1296px;
    margin: 0 auto;
}
.container {
    padding: 80px 25px 0 20px;
}

.service_header {
    display: flex;
    justify-content: space-between;
}
.main_title {
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 43px;
    color: #212529;
}
.info_btn {
    width: 251px;
    height: 48px;
    padding: 12px 30px;
    border: 1px solid #356EEF;
    color: #356EEF;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.overlay {
    z-index: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.45);
}

.modal {
    position: fixed;
    z-index: 101;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
    z-index: 2;
    width: 651px;
    height: auto;
    padding: 30px 30px 30px 30px;
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 15px;
    z-index: 999;
}

.modal_header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #CED4DA;
    width: 100%;
    padding-bottom: 10px;
    position: relative;
    align-items: center;
}

.modal_header_title {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    text-align: center;
    color: #000000;
    padding: 0;
    margin: 0;
}

.close_modal {
    cursor: pointer;
}

.modal_content {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #151920;
    margin-top: 14px;
}

.cal_cards {
    display: flex;
    gap: 20px;
    margin-top: 48px;
}

.cal_card img {
    width: 100%;
    max-width: 300px;
    height: auto;
    text-align: center;
}

.cal_card span {
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    color: #000000;
    padding-top: 24px;
}

.cal_card:hover span {
    color: #356EEF;
}

.cal_card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

@media (max-width: 680px) {
    .modal {
        width: 100%;
    }
    .service_header {
        flex-direction: column;
    }
    .info_btn {
        width: 100%;
        justify-content: center;
    }
    .main_title {
        font-size: 27px;
        line-height: 36px;
    }
}

.services-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 24px;
    margin-top: 48px;
}

.service-item {
    max-width: 416px;
    height: 187px;
    background: #FFFFFF;
    border-radius: 8px;
    border-left: 6px solid #C8E4FF;
    border-top: 1px solid #C8E4FF;
    border-right: 1px solid #C8E4FF;
    border-bottom: 1px solid #C8E4FF;
    cursor: pointer;
}

.service-item:hover {
    border-left: 6px solid #356EEF;
    box-shadow: 0px 5px 30px rgba(53, 110, 239, 0.18);
}

.service_title {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;
    color: #000000;
    margin: 0;
    margin-bottom: 10px;
}

.service_description {
    /* font-family: 'Helvetica Neue'; */
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #3A3A3A;
    margin: 0;
}

.service-item_content {
    display: flex;
    gap: 30px;
    padding: 30px 19px;
}

.service_img {
    display: flex;
    width: 100px;
}

@media (min-width: 1920px) {
    .services-list {
        gap: 24px;
    }
}

@media (max-width: 1190px) {
    .service_title {
        font-size: 15px;
        line-height: 20px;
    }
    .service_description {
        font-size: 10px;
        line-height: 21px;
    }
}

@media (max-width: 1100px) {
    .services-list {
        grid-template-columns: 1fr 1fr;
        gap: 24px;
    }
    .service_title {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
    }
    .service_description {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
    }
}

@media (max-width: 930px) {
    .mt-8 {
        margin-top: 40px!important;
    }

    .service-item_content {
        padding: 24px 10px;
        gap: 20px;
    }
    .service_img img {
        width: 90px;
        height: auto;
    }
}

@media (max-width: 760px) {
    .services-list {
        grid-template-columns: 1fr;
        gap: 24px;
    }
    .service-item {
        max-width: 100%;
        height: auto;
    }
    .container {
        padding: 50px 1rem 0 1rem;
    }
}

@media (max-width: 420px) {
    .service_img img {
        width: 60px;
        height: fit-content;
    }
    .service_description {
        font-size: 14px;
        line-height: 21px;
    }
    .title {
        font-size: 30px;
        line-height: 42px;
    }
}
</style>
